import React from 'react';
import { getCenter, getMap, getZoom, hoverModelAtPoint } from '../../interface/';

import ModelWrapper from '../Model/ModelWrapper';
import Lights from '../Lights/Lights';

class Scene extends React.Component {
  state = {
    zoom: 0,
    viewLat: null,
    viewLng: null,
  };

  componentDidMount() {
    const { history } = this.props;
    this.map = getMap();
    this.onPlaceClick = (placeId) => {
      history.push({ pathname: `/place/${placeId}` });
    };

    this.syncViewport = () => {
      const center = getCenter();
      this.setState({
        zoom: getZoom(),
        viewLat: center?.lat ?? null,
        viewLng: center?.lng ?? null,
      });
    };

    this.stopMove = this.map.on('move', this.syncViewport);
    this.onPointerMove = (event) => {
      const point = event?.point;
      if (!point) {
        return;
      }
      hoverModelAtPoint(point.x, point.y);
    };
    this.stopPointerMove = this.map.on('pointermove', this.onPointerMove);
    this.syncViewport();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeModels !== this.props.activeModels) {
      const modelArray = Object.values(this.props.activeModels);
      this.setState({ modelArray });
    }
  }

  componentWillUnmount() {
    this.stopMove?.();
    this.stopPointerMove?.();
  }

  renderModels = () => {
    const {
      activeModels,
      modelData,
      places,
      fetchModelFile,
      saveUUIDs,
      mapId,
      modelBlobs,
      settings,
      uuids,
    } = this.props;

    const { zoom, viewLat, viewLng } = this.state;

    return Object.values(modelData).map((model) => {
      const activeModel = activeModels[model.id];
      const textures = activeModel ? activeModel.textures : model.textures;
      const pngTransparencyEnabled =
        activeModel?.png_transparency_enabled ?? model.png_transparency_enabled;
      return (
        <ModelWrapper
          key={model.id}
          places={places}
          placeIds={model.placeIds}
          mapId={mapId}
          fetchModel={fetchModelFile}
          modelBlob={modelBlobs[model.id]}
          settings={settings}
          zoom={zoom}
          viewLat={viewLat}
          viewLng={viewLng}
          fileName={model.fileName}
          textures={textures}
          modelId={model.id}
          minZoom={settings.minzoom}
          pngTransparencyEnabled={pngTransparencyEnabled}
          saveUUIDs={saveUUIDs}
          uuids={uuids}
          onPlaceClick={this.onPlaceClick}
        />
      );
    });
  };

  renderLights = () => {
    const { lights } = this.props;
    return <Lights lights={lights} />;
  };

  render() {
    const { lights, places } = this.props;
    const hasPlaces = places && Object.keys(places).length > 0;
    return (
      <>
        {hasPlaces && this.renderModels()}
        {lights && this.renderLights()}
      </>
    );
  }
}

export default Scene;
